import JWMButton from "@components/JWMButton/JWMButton";
import JWMLink from "@components/JWMLink/JWMLink";
import { Icon, jnjArrowLeft } from "@jmc/solid-design-system/src/components/atoms/Icon/Icon";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { ClientOnly } from "@jmc/utils/utils/client-only";
import { mdiChevronLeft } from "@mdi/js";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "../style.module.scss";

export const BackButton = (props: { urlString: string }): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();
    const { t } = useTranslation();

    const { urlString } = props;

    return jnjFullBranded ? (
        <ClientOnly>
            {urlString !== "" && (
                <div className={style.backButton}>
                    <div className={style.container}>
                        <JWMLink url={urlString} external={false} placement={`page:Recipe`} fullWidth={false}>
                            <Typography color="link-04" variant="label-02" weight="500">
                                <Icon
                                    icon={jnjArrowLeft}
                                    type="jnj"
                                    size="medium"
                                    color="inherit"
                                    verticalAlign="middle"
                                />
                                {t("Back", { ns: "recipe" })}
                            </Typography>
                        </JWMLink>
                    </div>
                </div>
            )}
        </ClientOnly>
    ) : (
        <ClientOnly>
            {urlString !== "" && (
                <JWMButton
                    disableLink={false}
                    buttonProps={{ variant: "outlined", color: "primary" }}
                    placement={`page:Recipe`}
                    text={t("Back", { ns: "recipe" })}
                    url={urlString}
                    external={false}
                    size={"medium"}
                    icon={mdiChevronLeft}
                />
            )}
        </ClientOnly>
    );
};
